import _ from 'lodash';

export const formatDate = (x) => {
  if (_.isNil(x)) {
    return null;
  }

  const d = new Date(x);
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
};
